<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <div class="mod-sys__dict">
      <el-form label-position="top"
               :inline="true"
               :model="dataForm"
               @keyup.enter.native="getDataList()">
        <el-row>
          <el-col :span="5">
            <el-form-item :label="$t('couse.groupName')">
              <el-input v-model="dataForm.groupName"
                        :placeholder="$t('couse.groupName')"
                        clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item
                    :label="$t('couse.createUserName')">
              <el-input v-model="dataForm.createUserName"
                        :placeholder="$t('couse.createUserName')"
                        clearable></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="5">
            <el-form-item v-if="dataForm.pid !== '0'"
                          :label="$t('dict.dictValue')">
              <el-input v-model="dataForm.dictValue"
                        :placeholder="$t('dict.dictValue')"
                        clearable></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="4"
                  class="fr">
            <el-form-item>
              <el-button class="M-search"
                         type="primary"
                         @click="getDataList()">{{ $t('query') }}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="btn-left">
          <!-- <p>{{inputvalues}}</p>
          <el-input v-model="inputvaluesz"></el-input> -->
          <el-button class="el-button-columnBtn"
                     @click="toggleSelectioncreat()">选中</el-button>
        </div>
      </el-form>
      <el-table v-loading="dataListLoading"
                ref="multipleTablekz"
                height="250"
                :data="dataList"
                border
                style="width: 100%;">
        <!-- @selection-change="dataListSelectionChangeHandle"
                @sort-change="dataListSortChangeHandle" -->
        <el-table-column type="selection"
                         header-align="center"
                         align="center"
                         width="50"></el-table-column>
        <el-table-column prop="groupName"
                         :label="$t('couse.groupName')"
                         header-align="center"
                         align="center"></el-table-column>
        <el-table-column prop="groupRemar"
                         :label="$t('couse.groupRemark')"
                         header-align="center"
                         align="center"></el-table-column>
        <el-table-column prop="createUserName"
                         :label="$t('couse.createUserName')"
                         header-align="center"
                         align="center"></el-table-column>

      </el-table>
      <!-- :total="total" -->
      <el-pagination v-if="dataForm.groupId === '0'"
                     :current-page="page"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="limit"
                     :total="total"
                     layout="total, sizes, prev, pager, next, jumper"
                     @size-change="pageSizeChangeHandle"
                     @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <!-- <add-or-update v-if="addOrUpdateVisible"
                     ref="addOrUpdate"
                     @refreshDataList="getDataList"></add-or-update> -->
    </div>
  </el-card>
</template>
<script>
import mixinViewModule from '@/mixins/view-module'
// import AddOrUpdate from './dict-add-or-update'
// import { moduleRoutes } from '@/router'
export default {
  mixins: [mixinViewModule],
  props: {
    inputvalues: String
  },
  data () {
    return {
      inputvaluesz: '',
      mixinViewModuleOptions: {
        activatedIsNeed: false,
        getDataListURL: '/sys/commdict/list',
        getDataListIsPage: true

      },
      datalist: [],
      dataForm: {
        groupId: '0',
        groupName: '',
        groupRemark: '',
        createUserName: ''
      }
    }
  },
  components: {
    //  AddOrUpdate
  },
  created () { // this.$message("11111111111111");
    // 通过路由参数pid, 控制列表请求操作
    this.dataForm.groupId = this.$route.params.groupId || '0'
    console.log('groupId: == ' + this.dataForm.groupId)
    if (this.dataForm.groupId !== '0') {
      this.mixinViewModuleOptions.getDataListURL = '/sys/commdict/list'
      this.mixinViewModuleOptions.getDataListIsPage = true
      this.dataForm.dictType = this.$route.params.type || ''
    }
    console.log(this.dataForm)
    this.getDataList()
  },
  activated () {
    // 通过路由参数pid, 控制列表请求操作
    this.dataForm.pid = this.$route.params.pid || '0'
    if (this.dataForm.pid !== '0') {
      this.mixinViewModuleOptions.getDataListURL = '/sys/commdict/list'
      this.mixinViewModuleOptions.getDataListIsPage = true
      this.dataForm.dictType = this.$route.params.type || ''
    }
    this.getDataList()
  },
  methods: {
    toggleSelectioncreat () {
      // let ids = this.selections.map(item => item.id).toString()
      var chexcksss = this.$refs.multipleTablekz.selection// 得到选中的值
      chexcksss.forEach(row => {
        this.datalist.push({ groupId: row.groupId, groupName: row.groupName, groupRemark: row.groupRemark, createUserName: row.createUserName })
      })
      // this.$message('1111' + valus)
      // this.inputvalues=valus;
      // this.input=valus;
      // this.$message("ssssssss"+this.inputvalues);
      // this.$message("sssssssssssss"+rows);
      // this.$emit('inputss',[{names:valus,indexsx:this.inputvalues}] ); //暂时不用
      // this.$emit('inputss', valus)
      this.$emit('courescreat', this.datalist)
    }
    // // 子级
    // childHandle (row) {
    //   // 组装路由名称, 并判断是否已添加, 如是: 则直接跳转
    //   var routeName = `${this.$route.name}__${row.id}`
    //   var route = window.SITE_CONFIG['dynamicRoutes'].filter(item => item.name === routeName)[0]
    //   if (route) {
    //     // return this.$router.push({ name: routeName, params: { 'pid': row.id } })
    //     // 原框架此处存在问题，需要继续传递dictype
    //     return this.$router.push({ name: routeName, params: { 'pid': row.id, 'type': row.dictType } })
    //   }
    //   // 否则: 添加并全局变量保存, 再跳转
    //   route = {
    //     path: routeName,
    //     component: () => import(`@/views/modules/${this.$route.name.replace(/-/g, '/')}`),
    //     name: routeName,
    //     meta: {
    //       ...window.SITE_CONFIG['contentTabDefault'],
    //       menuId: this.$route.meta.menuId,
    //       title: `${this.$route.meta.title} - ${row.dictType}`
    //     }
    //   }
    //   this.$router.addRoutes([
    //     {
    //       ...moduleRoutes,
    //       name: `main-dynamic__${route.name}`,
    //       children: [route]
    //     }
    //   ])
    //   window.SITE_CONFIG['dynamicRoutes'].push(route)
    //   this.$router.push({ name: route.name, params: { 'pid': row.id, 'type': row.dictType } })
    // }

  }
}
</script>
